import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';

const LanguageMultiSelect = ({
  label,
  options = [],
  value = [],
  onChange,
  helperText,
  required = false,
  disabled = false,
}) => {
  const { theme } = useTheme();

  const normalizedValue = Array.isArray(value) ? value : [];

  const toggleOption = (option) => {
    if (disabled || typeof onChange !== 'function') {
      return;
    }

    const nextValue = normalizedValue.includes(option)
      ? normalizedValue.filter((item) => item !== option)
      : [...normalizedValue, option];

    onChange(nextValue);
  };

  const styles = {
    container: {
      width: '100%',
      marginBottom: '20px',
    },
    label: {
      display: 'block',
      marginBottom: '8px',
      fontSize: '14px',
      fontWeight: '600',
      color: theme.colors.text,
    },
    chipGrid: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: '8px',
    },
    chip: (selected) => ({
      padding: '7px 12px',
      borderRadius: '999px',
      border: `1px solid ${selected ? theme.colors.primary : theme.colors.border}`,
      backgroundColor: selected ? `${theme.colors.primary}12` : theme.colors.cardBg,
      color: selected ? theme.colors.primary : theme.colors.text,
      fontSize: '13px',
      fontWeight: '600',
      cursor: disabled ? 'not-allowed' : 'pointer',
      opacity: disabled ? 0.6 : 1,
    }),
    helperText: {
      marginTop: '6px',
      fontSize: '13px',
      color: theme.colors.textSecondary,
    },
  };

  return (
    <div style={styles.container}>
      {label && (
        <label style={styles.label}>
          {label}
          {required && <span style={{ color: theme.colors.error }}> *</span>}
        </label>
      )}

      <div style={styles.chipGrid}>
        {options.map((option) => {
          const selected = normalizedValue.includes(option);
          return (
            <button
              key={option}
              type="button"
              style={styles.chip(selected)}
              onClick={() => toggleOption(option)}
              disabled={disabled}
            >
              {option}
            </button>
          );
        })}
      </div>

      {helperText && <div style={styles.helperText}>{helperText}</div>}
    </div>
  );
};

export default LanguageMultiSelect;